import { CliError } from "../cli/cli-error";
import type { SessionDetail } from "@/lib/session/session-detail";

/**
 * What a followed session means for the caller's exit code.
 *
 * `followSession` returns on two very different conditions — the work is over,
 * or it needs a person — and both `run --follow` and `sessions logs --follow`
 * have to tell them apart the same way. Returns null when the session
 * completed (exit 0), a CliError carrying 3 when a human is needed, and 1 for
 * a real failure. The session rides on the error so `--json` can emit one
 * document holding both the outcome and what it applies to.
 */
export function sessionOutcome(session: SessionDetail): CliError | null {
  switch (session.status) {
    case "completed":
      return null;
    case "waiting_human":
      return new CliError(
        `Waiting on an answer — \`hepha questions list --session ${session.id}\``,
        3,
        {},
        session,
      );
    case "awaiting_approval":
      return new CliError(
        "Waiting on a guardrail approval — `hepha approvals list`",
        3,
        {},
        session,
      );
    default:
      return new CliError(
        `Session ended ${session.status}${session.statusReason ? `: ${session.statusReason}` : "."}`,
        1,
        {},
        session,
      );
  }
}
